import { checkDeviceType } from '@/src/utils/browser'
import { useRouter } from 'next/navigation'

const useRedirectFromWallet = () => {
    const router = useRouter()

    const goBackFromWallet = ({ isReloadRequired = false } = {}) => {
        // Check if running in Android app
        if (checkDeviceType() === 'AndroidApp') {
            window?.MobileApp?.onBackBtnClick?.('WALLET_PAGE')
        }
        // Check if running in iOS app
        else if (typeof window?.webkit?.messageHandlers['WALLET_PAGE'] == 'object') {
            window.webkit.messageHandlers['WALLET_PAGE'].postMessage('')
        }
        // Check if running in iframe with Android app
        else if (window.parent.androidData && (window.parent.androidData as any)['app-agent']) {
            window.parent?.MobileApp?.onBackBtnClick?.('WALLET_PAGE')
        }
        // Check if running in iframe with iOS app
        else if (window?.parent?.iosData && (window.parent.iosData as any)['app-agent']) {
            window.parent?.webkit?.messageHandlers?.['WALLET_PAGE']?.postMessage('')
        }
        // Fallback: redirect to home
        else if (isReloadRequired) {
            window.location.href = '/'
        } else {
            router.push('/')
        }
    }

    return goBackFromWallet
}

export default useRedirectFromWallet
